// extracted by mini-css-extract-plugin
export default {"resetButton":"fQKZhOe","root":"FiFDp9K","transparent":"epOUBAn","zerostate":"qiWfBPE","accent":"B3Qbr67"};